import {getMessagingInstance, getToken, onMessage} from './firebase.js'
import userService from "../helpers/user.service";
import MensagemService from "../Services/Mensagem.service";
import Helper from "../helpers/helper.service";

export async function initWebPush() {
  try {

    const modoAluno = (window.localStorage.getItem("idModoAluno")) ? true : false
    if(modoAluno)
      return

    const isHttps = window.location.protocol === 'https:'
    const isLocalhost =
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'

    if (!isHttps && !isLocalhost) {
      console.warn('Notificações web requerem HTTPS ou localhost.')
      return
    }

    if (!('Notification' in window)) {
      console.warn('Este navegador não suporta notificações.')
      return
    }

    if (!('serviceWorker' in navigator)) {
      console.warn('Service workers não são suportados neste navegador.')
      return
    }

    const messaging = await getMessagingInstance()
    if (!messaging) {
      console.warn('Firebase Messaging não é suportado neste navegador.')
      return
    }

    const permission = await Notification.requestPermission()
    if (permission !== 'granted') {
      console.warn('Permissão de notificações foi negada. O usuário precisa habilitar manualmente nas configurações do navegador.');
      return
    }

    // Registra o service worker
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js')

    // Aguarda o service worker estar pronto
    await registration.ready

    // Aguarda o service worker estar realmente ativo
    // Isso é necessário porque o PushManager requer um service worker ativo
    if (!registration.active) {
      await new Promise((resolve) => {
        const checkActive = () => {
          if (registration.active) {
            resolve()
          } else {
            setTimeout(checkActive, 50)
          }
        }
        checkActive()

        // Timeout de segurança (10 segundos)
        setTimeout(() => resolve(), 10000)
      })
    }

    // Aguarda um pouco mais para garantir que o service worker está totalmente pronto
    await new Promise(resolve => setTimeout(resolve, 200))

    // Gera o token FCM
    const token = await getToken(messaging, {
      vapidKey: 'BD5u8cIxpi_t9kvZcrx7OiID6n9HUPxV0OJ8E-OnfikYInkXpXyUN4vVWkcJ481PGbdd6Hkm7a1gRt3IrvYnRKY',
      serviceWorkerRegistration: registration,
    })

    if (!token) {
      console.warn('Não foi possível obter o token FCM.')
      return
    }

    // Verifica se é um token novo ou já existente
    const storedToken = localStorage.getItem('fcm_token')
    const isNewToken = storedToken !== token

    if (isNewToken && token) {
      // console.log('🎯 Novo Token Web FCM:', token)

      try {

        // Obtém o usuário logado
        const usuario = userService.getUser();
        if (!usuario || !usuario.IdUsuario) {
          throw new Error('Usuário não encontrado para salvar CFM token')
        }

        const data = {
          IdUsuario: usuario.IdUsuario,
          Token: token
        }

        const result = await MensagemService.gravarToken(data);
        if (!result.Success)
          throw new Error(Helper.getMessageError(result))

        // console.log("update token:", token)
        localStorage.setItem('fcm_token', token)

      } catch (error) {
        // console.error('Erro ao  atualizar CFM token: ', error);
      }

    } else {
      // console.log('✅ Token Web FCM já existe:', token)
    }

    // Ouvir notificações recebidas em primeiro plano
    onMessage(messaging, (payload) => {

      // console.log('Notificação:', payload)
      const mensagem = payload.notification.body.slice(0, 60);

      swalToast.fire({
        timer: 15000,
        html: `<a href="${payload.data.link}">Notificação: ${payload.notification.title} - ${mensagem}</a>`,
        icon: 'info',
      })

    })

  } catch (err) {
    console.error('Erro ao inicializar notificações web:', err)
  }
}
